/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateInstrumentSelectionRequest} from '@cash-web/protos/squareup/cash/out/api/v1_0/InstrumentSelection.pb'
import {InitiateInstrumentSelectionResponse} from '@cash-web/protos/squareup/cash/out/api/v1_0/InstrumentSelection.pb'


export const initiateCashOutInstrumentSelection = (request: InitiateInstrumentSelectionRequest, options?: CashRequestOptions) => post<InitiateInstrumentSelectionRequest, InitiateInstrumentSelectionResponse>("/cash-app/out/v1.0/initiate-instrument-selection", request, {...options, rejectOnError: true })